import React from 'react';
import { withRouter } from 'react-router-dom';
import Button from "@material-ui/core/Button/Button";
import Card from "@material-ui/core/Card/Card";
import Grid from "@material-ui/core/Grid/Grid";
import makeStyles from "@material-ui/core/styles/makeStyles";

import PltwNavBar from '../../common/pltwNavBarLogin';

import './pageNotFound-styles.scss';

const useStyles = makeStyles(() => ({
  button: {
    marginBottom: 20,
    backgroundColor: '#283f60',
    color: 'white',
    border: '1px solid #1a314c',
    '&:hover': {
      backgroundColor: '#1a314c',
      border: '1px solid #f6edd4',
    }
  },
  card: {
    border: '3px solid transparent',
    borderImage: 'linear-gradient(left, #99d6ce 15%, #f2642f 50%, #f8c12c 90%) 30',
    boxShadow: '0 0 20px 2px #283f60',
  },
}));

const PageNotFound = ({ history }) => {
  const classes = useStyles();
  return (
      <div>
        <PltwNavBar />
        <div className='not-found'>
          <Grid container justify='center' alignItems='center'>
            <Grid item xs={10} sm={5}>
              <Card className={classes.card}>
                <h1>Oops!</h1>
                <h2>404 - Page not found</h2>
                <p>Sorry, the page you requested was not found.</p>
                <Button className={classes.button} onClick={() => history.push('/')}>Back to home</Button>
              </Card>
            </Grid>
          </Grid>
      </div>
    </div>
  );
};

export default withRouter(PageNotFound);
